import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

export const fetchSummary = createAsyncThunk(
  "summary/fetchSummary",
  async ({ search, page, rowsPerPage, month, year, client, channel }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}project/summary?search=${search}&page=${
          page + 1
        }&limit=${rowsPerPage}&month=${month || ""}&year=${year || ""}&client=${client||null}&channel=${channel||""}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch summarys." }
      );
    }
  }
);

export const getPDF = createAsyncThunk(
  "get/pdf",
  async (datas, { rejectWithValue }) => {
    const token = getToken();
    
    if (!token) {
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });
    }

    try {
      const response = await axios.post(
        `${Apiurl}admin/userlist/update-user-id`,
        datas, 
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "PDF Download!",
        text: "PDF Generated Successfully",
        timer: 3000,
      });

      return response.data;

    } catch (error) {
      // Enhanced error handling
      const errorMessage = error.response?.data?.message || "Please try again later.";
      
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: errorMessage,
        timer: 3000,
      });

      return rejectWithValue(
        error.response?.data || { 
          message: errorMessage,
          status: error.response?.status 
        }
      );
    }
  }
);

const initialState = {
  summaryData: [],
  count: 0,
  loading: false,
  sumStatus: "idle",
  pdfStatus: "idle",
  error: null,
};

const summarySlice = createSlice({
  name: "summary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummary.pending, (state) => {
        state.error = null;
        state.sumStatus = "pending";
      })
      .addCase(fetchSummary.fulfilled, (state, action) => {
        state.summaryData = action.payload.data;
        state.count = action.payload.total;
        state.sumStatus = "succeeded";
      })
      .addCase(fetchSummary.rejected, (state, action) => {
        state.error = action.payload;
        state.sumStatus = "failed";
      })
      .addCase(getPDF.pending, (state) => {
        state.error = null;
        state.pdfStatus = "pending";
      })
      .addCase(getPDF.fulfilled, (state, action) => {
        state.pdfStatus = "succeeded";
      })
      .addCase(getPDF.rejected, (state, action) => {
        state.error = action.payload;
        state.pdfStatus = "failed";
      });
  },
});

export default summarySlice.reducer;
